<template>
    <div id="floating-chatroom">
        <div class="floating-wrapper">
            <div class="contact-container">
                <div class="filterist">
                    <div class="lftTopContent">
                        <h1>Admin Chat</h1>
                    </div>
                    <div class="lftBottomContent">
                        <a-input-search
                            :placeholder="'find_user'"
                            style="width: 150px"
                            v-model="filteredNotUserName"
                        />
                    </div>
                </div>
                <div v-if="onLoadingCareroom" class="contact-list">
                    <div
                        v-for="chatroom in [1, 2, 3, 4, 5, 6]"
                        :key="`chatroom-skel-${chatroom}`"
                        class="contact-item"
                    >
                        <div class="chatContent">
                            <p class="chatName"><a-spin size="small" /></p>
                        </div>
                    </div>
                </div>
                <div v-else class="contact-list">
                    <div
                        v-for="chatroom in fittedCareRooms"
                        :key="`chatroom-${chatroom.id}`"
                        class="contact-item"
                        :class="{
                            'selected-chatroom': checkIsSelectedCareroom(
                                chatroom
                            )
                        }"
                        @click="() => handleSelectCareRoom(chatroom)"
                    >
                        <div class="chatImgWrapper">
                            <img
                                class="chatImg"
                                :src="chatroom.Member.profilePicUrl"
                                :onerror="
                                    `this.onerror=null;this.src='https://place-hold.it/100x100?text=${getUserFirstChar(
                                        chatroom.Member
                                    )}&fontsize=42';`
                                "
                            />
                        </div>
                        <div class="chatContent">
                            <p
                                class="chatName"
                                :class="{
                                    'text-bold': isHaveNewUserMessage(
                                        chatroom.id
                                    )
                                }"
                            >
                                {{
                                    chatroom.Member.name ||
                                        chatroom.Member.email
                                }}
                            </p>
                        </div>
                        <a-badge v-if="isHaveNewUserMessage(chatroom.id)" dot />
                    </div>
                </div>
            </div>
            <div class="chatroom-container">
                <div class="left-wrapper">
                    <div
                        class="topist"
                        :class="{ 'no-active-chat-topist': isNoActiveChat }"
                    >
                        <div v-if="!isNoActiveChat" class="chat-user-wrapper">
                            <div class="user-avatar">
                                <img
                                    class="headerImg"
                                    :src="selectedCareRoom.Member.profilePicUrl"
                                    :onerror="
                                        `this.onerror=null;this.src='https://place-hold.it/100x100?text=${getUserFirstChar(
                                            selectedCareRoom.Member
                                        )}&fontsize=42';`
                                    "
                                />
                            </div>
                            <div class="user-info">
                                <div class="user-name">
                                    <p>
                                        {{
                                            selectedCareRoom.Member.name ||
                                                selectedCareRoom.Member.email
                                        }}
                                    </p>
                                </div>
                                <p
                                    v-if="
                                        selectedCareRoom.Member
                                            .ProfessionDetailId &&
                                            selectedCareRoom.Member
                                                .ProfessionDetail.businessName
                                    "
                                >
                                    {{ 'business_owner' }}
                                </p>
                                <p v-else>{{ 'propertigrab_member' }}</p>
                            </div>
                        </div>
                        <div class="close-wrapper">
                            <a-icon type="down" @click="handleClose" />
                        </div>
                    </div>
                    <div v-if="isNoActiveChat" class="empty-chatroom-wrapper">
                        <a-empty
                            :title="'no_chat.title'"
                            :description="'no_chat.desc'"
                        />
                    </div>
                    <div v-else class="chatroom-wrapper">
                        <div v-if="onLoadingChatMessage" class="chatroom">
                            <a-spin class="center-spin" />
                        </div>
                        <div v-else class="chatroom" ref="cBcontainer">
                            <div class="chatbox">
                                <div
                                    v-for="chatMessage in careMessages"
                                    :key="`chat-message-day-${chatMessage.day}`"
                                >
                                    <div class="day-break">
                                        <span>{{
                                            chatMessage.day | date('day-only')
                                        }}</span>
                                    </div>
                                    <div
                                        v-for="cm in chatMessage.times"
                                        :key="
                                            `chat-message-chatroom-${cm.chatRoomId}-${cm.id}`
                                        "
                                        :class="{
                                            'chat-item-right': checkIsMyChatMessage(
                                                cm
                                            ),
                                            'chat-item-left': !checkIsMyChatMessage(
                                                cm
                                            )
                                        }"
                                    >
                                        <div class="chat-bubble">
                                            <div
                                                v-if="cm.withContext"
                                                class="chat-with-context"
                                            >
                                                <div
                                                    v-if="
                                                        cm.propertyId !== null
                                                    "
                                                    class="inner property-context"
                                                >
                                                    <div
                                                        class="context-content"
                                                    >
                                                        <div
                                                            class="context-image-container"
                                                        >
                                                            <img
                                                                class="context-image"
                                                                :src="
                                                                    cm.Property
                                                                        .imageUrls[0]
                                                                        .url ||
                                                                        cm
                                                                            .Property
                                                                            .imageUrls[0]
                                                                            .src
                                                                "
                                                                alt="property"
                                                            />
                                                        </div>
                                                        <div
                                                            class="context-text-container"
                                                        >
                                                            <p
                                                                class="title-context"
                                                            >
                                                                {{
                                                                    cm.Property
                                                                        .name
                                                                }}
                                                            </p>
                                                            <div
                                                                class="context-tag-container"
                                                            >
                                                                <div
                                                                    class="context-tag"
                                                                >
                                                                    <div
                                                                        class="tag-wrapper"
                                                                    >
                                                                        <p
                                                                            color=""
                                                                            class="tag-text"
                                                                            style="color: var(--NN600, #6D7588);"
                                                                        >
                                                                            {{
                                                                                cm
                                                                                    .Advertisement
                                                                                    .usage
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="context-tag"
                                                                >
                                                                    <div
                                                                        class="tag-wrapper"
                                                                    >
                                                                        <p
                                                                            color=""
                                                                            class="tag-text"
                                                                            style="color: var(--NN600, #6D7588);"
                                                                        >
                                                                            {{
                                                                                'ads_type.property'
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <h5
                                                                class="bold-text"
                                                            >
                                                                Rp{{
                                                                    cm
                                                                        .Advertisement
                                                                        .price
                                                                        | currency(
                                                                            'splitter'
                                                                        )
                                                                }}
                                                                <span
                                                                    v-if="
                                                                        cm
                                                                            .Advertisement
                                                                            .usage ===
                                                                            'rent'
                                                                    "
                                                                    class="rent-duration"
                                                                    >{{
                                                                        `rent_duration_${cm.Advertisement.priceDuration}`
                                                                    }}</span
                                                                >
                                                            </h5>
                                                            <div
                                                                class="regular-text"
                                                            >
                                                                {{
                                                                    cm.Property
                                                                        .addressProvince
                                                                }},
                                                                {{
                                                                    cm.Property
                                                                        .addressCity
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="cta-button">
                                                        <div
                                                            class="button-container"
                                                        >
                                                            <button
                                                                @click="
                                                                    redirectToPropertyAdsPage(
                                                                        cm
                                                                            .Advertisement
                                                                            .id
                                                                    )
                                                                "
                                                                class="unf-btn unf-btn--animate unf-btn--small unf-btn--block css-4mtg7i-unf-btn e1512idj0"
                                                                type="button"
                                                            >
                                                                <div
                                                                    class="button-text-container"
                                                                >
                                                                    <span>{{
                                                                        'view_detail'
                                                                    }}</span>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="checkmark">
                                                        <div
                                                            class="checkmark-wrapper"
                                                        >
                                                            <div
                                                                class="aligner"
                                                            >
                                                                <span
                                                                    class="time-jumble"
                                                                    >{{
                                                                        cm.createdAt
                                                                            | date(
                                                                                'only-time'
                                                                            )
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="cm.projectId !== null"
                                                    class="inner project-context"
                                                >
                                                    <div
                                                        class="context-content"
                                                    >
                                                        <div
                                                            class="context-image-container"
                                                        >
                                                            <img
                                                                class="context-image"
                                                                :src="
                                                                    cm.Project
                                                                        .developerLogo
                                                                        .url ||
                                                                        cm
                                                                            .Project
                                                                            .developerLogo
                                                                            .src
                                                                "
                                                                alt="project"
                                                            />
                                                        </div>
                                                        <div
                                                            class="context-text-container"
                                                        >
                                                            <p
                                                                class="title-context"
                                                            >
                                                                {{
                                                                    cm.Project
                                                                        .name
                                                                }}
                                                            </p>
                                                            <div
                                                                class="context-tag-container"
                                                            >
                                                                <div
                                                                    class="context-tag"
                                                                >
                                                                    <div
                                                                        class="tag-wrapper"
                                                                    >
                                                                        <p
                                                                            color=""
                                                                            class="tag-text"
                                                                            style="color: var(--NN600, #6D7588);"
                                                                        >
                                                                            {{
                                                                                cm
                                                                                    .Advertisement
                                                                                    .usage
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="context-tag"
                                                                >
                                                                    <div
                                                                        class="tag-wrapper"
                                                                    >
                                                                        <p
                                                                            color=""
                                                                            class="tag-text"
                                                                            style="color: var(--NN600, #6D7588);"
                                                                        >
                                                                            {{
                                                                                'ads_type.project'
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <h5
                                                                class="bold-text"
                                                            >
                                                                <span
                                                                    class="start-from"
                                                                    >{{
                                                                        'start_from'
                                                                    }}</span
                                                                >
                                                                Rp{{
                                                                    cm
                                                                        .Advertisement
                                                                        .minPrice
                                                                        | currency(
                                                                            'splitter'
                                                                        )
                                                                }}
                                                            </h5>
                                                            <div
                                                                class="regular-text"
                                                            >
                                                                {{
                                                                    cm.Project
                                                                        .addressProvince
                                                                }},
                                                                {{
                                                                    cm.Project
                                                                        .addressCity
                                                                }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="cta-button">
                                                        <div
                                                            class="button-container"
                                                        >
                                                            <button
                                                                @click="
                                                                    redirectToProjectAdsPage(
                                                                        cm
                                                                            .Advertisement
                                                                            .id
                                                                    )
                                                                "
                                                                class="unf-btn unf-btn--animate unf-btn--small unf-btn--block css-4mtg7i-unf-btn e1512idj0"
                                                                type="button"
                                                            >
                                                                <div
                                                                    class="button-text-container"
                                                                >
                                                                    <span>{{
                                                                        'view_detail'
                                                                    }}</span>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="checkmark">
                                                        <div
                                                            class="checkmark-wrapper"
                                                        >
                                                            <div
                                                                class="aligner"
                                                            >
                                                                <span
                                                                    class="time-jumble"
                                                                    >{{
                                                                        cm.createdAt
                                                                            | date(
                                                                                'only-time'
                                                                            )
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="
                                                        cm.professionalServiceId !==
                                                            null
                                                    "
                                                    class="inner service-context"
                                                >
                                                    <div
                                                        class="context-content"
                                                    >
                                                        <div
                                                            class="context-image-container"
                                                        >
                                                            <img
                                                                class="context-image"
                                                                :src="
                                                                    cm
                                                                        .ProfessionalService
                                                                        .imageUrls[0]
                                                                        .url
                                                                "
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div
                                                            class="context-text-container"
                                                        >
                                                            <p
                                                                class="title-context"
                                                            >
                                                                {{
                                                                    cm
                                                                        .ProfessionalService
                                                                        .name
                                                                }}
                                                            </p>
                                                            <div
                                                                class="context-tag-container"
                                                            >
                                                                <div
                                                                    class="context-tag"
                                                                >
                                                                    <div
                                                                        class="tag-wrapper"
                                                                    >
                                                                        <p
                                                                            color=""
                                                                            class="tag-text"
                                                                            style="color: var(--NN600, #6D7588);"
                                                                        >
                                                                            {{
                                                                                'ads_type.service'
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <h5
                                                                class="bold-text"
                                                            >
                                                                Rp{{
                                                                    cm
                                                                        .ProfessionalService
                                                                        .price
                                                                        | currency(
                                                                            'splitter'
                                                                        )
                                                                }}
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div class="cta-button">
                                                        <div
                                                            class="button-container"
                                                        >
                                                            <button
                                                                @click="
                                                                    redirectToServicePage(
                                                                        cm
                                                                            .ProfessionalService
                                                                            .id
                                                                    )
                                                                "
                                                                class="unf-btn unf-btn--animate unf-btn--small unf-btn--block css-4mtg7i-unf-btn e1512idj0"
                                                                type="button"
                                                            >
                                                                <div
                                                                    class="button-text-container"
                                                                >
                                                                    <span>{{
                                                                        'view_detail'
                                                                    }}</span>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="checkmark">
                                                        <div
                                                            class="checkmark-wrapper"
                                                        >
                                                            <div
                                                                class="aligner"
                                                            >
                                                                <span
                                                                    class="time-jumble"
                                                                    >{{
                                                                        cm.createdAt
                                                                            | date(
                                                                                'only-time'
                                                                            )
                                                                    }}</span
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                v-if="cm.imageUrls !== null"
                                                class="chat-image"
                                            >
                                                <img
                                                    :src="cm.imageUrls.url"
                                                    @click="
                                                        () =>
                                                            handleImageClick(
                                                                cm.imageUrls.url
                                                            )
                                                    "
                                                />
                                                <div class="chat-time-image">
                                                    <div
                                                        class="chat-image-container"
                                                    >
                                                        <span
                                                            class="chat-image-span"
                                                            >{{
                                                                cm.createdAt
                                                                    | date(
                                                                        'only-time'
                                                                    )
                                                            }}</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                v-else
                                                class="chat-bubble-inner"
                                            >
                                                <div class="chat-text">
                                                    <span
                                                        ><div
                                                            v-html="
                                                                urlify(
                                                                    cm.message
                                                                )
                                                            "
                                                    /></span>
                                                </div>
                                                <div class="chat-time-status">
                                                    <div
                                                        class="chat-time-status-inner"
                                                    >
                                                        <span
                                                            class="time-text"
                                                            >{{
                                                                cm.createdAt
                                                                    | date(
                                                                        'only-time'
                                                                    )
                                                            }}</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="action-container">
                                <div class="action-wrapper">
                                    <div class="input-container">
                                        <div class="textarea-container">
                                            <div class="chatbox-input">
                                                <a-upload
                                                    class="image-uploader"
                                                    :action="uploaderInfo.url"
                                                    :headers="
                                                        uploaderInfo.headers
                                                    "
                                                    :multiple="false"
                                                    :showUploadList="false"
                                                    :beforeUpload="
                                                        beforeUploadDoc
                                                    "
                                                    @change="
                                                        handleImageUploaderChanged
                                                    "
                                                >
                                                    <a-button
                                                        shape="circle"
                                                        size="small"
                                                    >
                                                        <a-icon
                                                            type="picture"
                                                        />
                                                    </a-button>
                                                </a-upload>
                                                <textarea
                                                    class="chat-textbox"
                                                    :rows="textAreaRow"
                                                    placeholder="Tulis pesan..."
                                                    v-model="careTextAreaValue"
                                                    @keydown="
                                                        handleKeyDownEvent
                                                    "
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        class="btn-send-message"
                                        @click="sendCareMessage"
                                    >
                                        <svg
                                            class="unf-icon"
                                            viewBox="0 0 24 24"
                                            width="22"
                                            height="22"
                                            fill="var(--NN0, #FFFFFF)"
                                            style="display: inline-block; vertical-align: middle;"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M21.35 11.32 5.66 3.19a1.81 1.81 0 0 0-1.81.28 1.8 1.8 0 0 0-.55 1.77L4.72 12 3.3 18.71a1.75 1.75 0 0 0 .7 1.81 1.68 1.68 0 0 0 1 .34c.266 0 .528-.069.76-.2l15.61-8a.759.759 0 0 0 .41-.67.77.77 0 0 0-.43-.67ZM5 19.34a.14.14 0 0 1-.15 0 .27.27 0 0 1-.1-.27L6 13.36l6.8-.87a.5.5 0 0 0 0-1L6 10.61 4.76 4.93a.33.33 0 0 1 .07-.32.32.32 0 0 1 .17-.06L19.36 12 5 19.34Z"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* apis */
import apiUtils from 'libs/util';
import careRoomApi from 'libs/careRoom';
import careMessageApi from 'libs/careMessage';
import userNotificationApi from 'libs/user-notification';

/* direct load components */
import { mapState } from 'vuex';
import moment from 'moment';
import * as _ from 'lodash';

/* libraries */
import AdminMixin from 'mixins/admin';
import AudioMixin from 'mixins/audio';
import errorPrinter from 'mixins/errorPrinter';
import dateFilter from 'filters/date';
import currency from 'filters/currency';
import urlify from 'filters/urlify';
import messages from './locale';
import adminNotificationMixin from 'mixins/adminNotificationMixin';

export default {
    name: 'FloatingChatroom',
    i18n: { messages },
    mixins: [errorPrinter, AdminMixin, AudioMixin, adminNotificationMixin],
    data: () => ({
        uploaderInfo: apiUtils.getUploaderInfo(),
        onLoadingCareroom: false,
        onLoadingChatMessage: false,
        onLoadingSendMessage: false,
        selectedCareRoom: null,
        filteredNotUserName: '',
        carerooms: [],
        careMessages: [],
        careTextAreaValue: '',
        chatImageUrls: null,
        textAreaRow: 1,
        userNotificationMap: [],
        chatFileList: []
    }),
    computed: {
        ...mapState(['chat']),
        adminId() {
            return this._getCurrentAdminId();
        },
        fittedCareRooms() {
            return this.carerooms.filter(n => {
                return this.filteredNotUserName !== ''
                    ? n.Member.name
                          .toLowerCase()
                          .includes(this.filteredNotUserName)
                    : true;
            });
        },
        isNoActiveChat() {
            return this.selectedCareRoom === null;
        }
    },
    filters: {
        date: dateFilter,
        currency
    },
    async mounted() {
        await this.indexListItem();
        await this.countCareroomUserNotification();
    },
    methods: {
        urlify,
        handleClose() {
            this.$emit('close');
        },
        handleImageClick(url) {
            let image = new Image();
            image.src = 'data:image/jpg;base64,' + url;
            let w = window.open('', '_blank');
            w.document.write(image.outerHTML);
        },
        handleSelectCareRoom(careroom) {
            this.selectedCareRoom = careroom;
            this.fetchCareMessages();
            this.runMultipleAck(careroom.id);
        },
        async indexListItem() {
            this.onLoadingCareroom = true;
            try {
                let { data } = await careRoomApi.index({
                    sortBy: 'updatedAt',
                    sortOrientation: 'DESC'
                });

                this.carerooms = data.data;

                if (this.chat.proxyChatRoomId !== -1) {
                    const chatroom = this.carerooms.find(
                        n => n.id === this.chat.proxyChatRoomId
                    );

                    if (chatroom) {
                        this.$store.dispatch('chat/resetProxyChatRoomId');
                        this.handleSelectCareRoom(chatroom);
                    }
                }
            } catch (err) {
                this.printError(err);
                throw err;
            } finally {
                this.onLoadingCareroom = false;
            }
        },
        getUserFirstChar(user) {
            let userFirstChar = 'A';

            if (user.name) {
                userFirstChar = user.name[0];
            } else {
                userFirstChar = user.email[0];
            }

            return userFirstChar;
        },
        async runMultipleAck(careRoomId) {
            const userNotif = this.userNotificationMap.find(
                n => n.careroomId === careRoomId
            );

            if (!userNotif) {
                return false;
            }

            await userNotificationApi.multipleAck(userNotif.userNotifIds);
            await this.indexListItem();
            await this.countCareroomUserNotification();
        },
        checkIsSelectedCareroom(careroom) {
            if (this.selectedCareRoom === null) return false;
            return careroom.id === this.selectedCareRoom.id;
        },
        async fetchCareMessages() {
            this.onLoadingChatMessage = true;
            this.careMessages = [];
            try {
                let { data } = await careMessageApi.index({
                    'findBy-careRoomId': `eq,careRoomId,${this.selectedCareRoom.id},number`
                });

                this.careMessages = data.data;

                // group chat message by day
                const groups = _.groupBy(this.careMessages, function(
                    chatMessage
                ) {
                    return moment(chatMessage.createdAt)
                        .startOf('day')
                        .format();
                });

                const groupingResult = _.map(groups, function(group, day) {
                    return {
                        day: day,
                        times: _.sortBy(group, 'createdAt')
                    };
                });

                const sortedGroupedResult = _.sortBy(groupingResult, 'day');

                this.careMessages = sortedGroupedResult;

                setTimeout(() => {
                    const cBcontainer = this.$refs['cBcontainer'];
                    if (cBcontainer) {
                        cBcontainer.scrollTop = cBcontainer.scrollHeight;
                    }
                }, 300);
            } catch (err) {
                this.printError(err);
                throw err;
            } finally {
                this.onLoadingChatMessage = false;
            }
        },
        checkIsMyChatMessage(careMessage) {
            return Boolean(careMessage.adminId);
        },
        async sendCareMessage() {
            if (!this.careTextAreaValue) return;
            if (this.selectedCareRoom === null) return;
            if (this.onLoadingChatMessage) return;

            this.onLoadingSendMessage = true;

            try {
                const {
                    data: newChatMessage
                } = await careMessageApi.sendMessage({
                    message: this.careTextAreaValue,
                    memberId: this.selectedCareRoom.Member.id,
                    careRoomId: this.selectedCareRoom.id,
                    adminId: this.adminId,
                    imageUrls: this.chatImageUrls
                });

                this.careTextAreaValue = '';
                this.chatImageUrls = null;
                this.careMessages[this.careMessages.length - 1].times.push(
                    newChatMessage
                );

                await this.$nextTick();

                setTimeout(() => {
                    const cBcontainer = this.$refs['cBcontainer'];
                    if (cBcontainer) {
                        cBcontainer.scrollTop = cBcontainer.scrollHeight;
                    }
                }, 300);
            } catch (err) {
                this.printError(err);
                throw err;
            } finally {
                this.onLoadingSendMessage = false;
            }
        },
        async handlingNewCareRoomEvent() {
            await this.indexListItem();
        },
        async onAdminNotification(event) {
            await this.handlingNewCareRoomEvent();

            if (!event || !event.data || this.selectedCareRoom === null) {
                await this.countCareroomUserNotification();
                return;
            }

            try {
                const parsedData = JSON.parse(event.data);
                const content = JSON.parse(parsedData.notif.message);
                const notificationData = JSON.parse(content.content);

                if (notificationData.carry && notificationData.carry.ChatMessage) {
                    await this.handlingNewCareMessageEvent(event);
                    return;
                }
            } catch (err) {
                // Non chat-message notifications (e.g. new care room)
            }

            await this.countCareroomUserNotification();
        },
        async handlingNewCareMessageEvent(event) {
            if (this.selectedCareRoom === null) {
                await this.countCareroomUserNotification();
                return;
            }

            const parsedData = JSON.parse(event.data);
            const content = JSON.parse(parsedData.notif.message);

            console.log('PARSE DATA:', parsedData);

            let notificationData = JSON.parse(content.content);

            await this.fetchCareMessages();
            await this.countCareroomUserNotification();
            this._playChatNotificationSound();

            if (
                this.selectedCareRoom.id ===
                    notificationData.carry.ChatMessage.chatRoomId &&
                this.chat.isOpen
            ) {
                this.runMultipleAck(this.selectedCareRoom.id);
            }
        },
        handleKeyDownEvent(event) {
            if (event.keyCode === 13 && !event.shiftKey) {
                event.preventDefault();
                this.sendCareMessage();
            }
            if (event.keyCode === 13 && event.shiftKey) {
                if (this.textAreaRow <= 3) {
                    this.textAreaRow = this.textAreaRow + 1;
                }
            }
            if (event.keyCode === 8) {
                const text = this.careTextAreaValue;
                const lines = text.split('\n');
                const rowCount = lines.length;
                if (rowCount <= 3) {
                    this.textAreaRow = rowCount;
                }
            }
        },
        redirectToPropertyAdsPage(propertyAdsId) {
            window.open(`/property-detail/${propertyAdsId}`, '_blank');
        },
        redirectToProjectAdsPage(projectAdsId) {
            window.open(`/project-detail/${projectAdsId}`, '_blank');
        },
        redirectToServicePage(professionalServiceId) {
            this._goToProfessionalPages(
                `p/service-detail/${professionalServiceId}`
            );
        },
        async countCareroomUserNotification() {
            let queryStr = '';

            for (let index = 0; index < this.fittedCareRooms.length; index++) {
                const fittedCareRoom = this.fittedCareRooms[index];

                if (index === 0) {
                    queryStr = `careroomIds[]=${fittedCareRoom.id}`;
                } else {
                    queryStr = `${queryStr}&careroomIds[]=${fittedCareRoom.id}`;
                }
            }

            const data = await userNotificationApi.countByCarerooms(queryStr);
            this.userNotificationMap = data.data;
        },
        isHaveNewUserMessage(careRoomId) {
            const userNotif = this.userNotificationMap.find(
                n => n.careroomId === careRoomId
            );
            if (!userNotif) {
                return false;
            }
            return userNotif.notifCount > 0;
        },
        beforeUploadDoc(file) {
            const isLt12M = file.size / 1024 / 1024 < 12;
            if (!isLt12M) {
                this.$message.error('File must smaller than 12MB');
            }
            return isLt12M;
        },
        handleImageUploaderChanged(info) {
            if (info.file.status === 'done') {
                this.careTextAreaValue = ' ';
                this.chatImageUrls = {
                    name: info.file.name,
                    url: info.file.response[0].path
                };
                this.sendCareMessage();
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} file upload failed.`);
            }
        }
    }
};
</script>

<style scoped lang="scss">
#floating-chatroom {
    max-height: calc(100vh - 233px);
    height: 450px;
    width: 560px;
    display: flex;
    position: fixed;
    right: 6%;
    bottom: 0px;
    background-color: var(--NN0, #ffffff);
    border-radius: 12px;
    box-shadow: 0 2px 30px 0 var(--NN300, #bfc9d9);
    z-index: 60;
    transition: all 0.2s ease-in-out 0s;
    transform: translateY(-40px);
    opacity: 1;
}

.floating-wrapper {
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
}

.contact-container {
    position: relative;
    flex: 0 0 auto;
    width: 30%;
    display: flex;
    flex-direction: column;
}

.chatroom-container {
    width: 70%;
    border-left: 1px solid var(--NN50, #f0f3f7);
}

.filterist {
    min-height: 87px;
    z-index: 2;
    display: flex;
    flex-direction: column;
    padding: 12px 8px 8px;
    box-shadow: var(--NN50, #f0f3f7) 0px 2px 4px 0px;

    .lftTopContent {
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        align-items: center;
        margin-bottom: 12px;
        color: var(--NN900, #2e3137);

        h1 {
            line-height: 1;
            font-size: 16px;
            font-weight: 700;
            margin: 0;
        }
    }

    .lftBottomContent {
        display: flex;
        gap: 4px;
    }
}

.contact-list {
    overflow-y: auto;
    z-index: 1;
    -webkit-box-flex: 1;
    flex-grow: 1;
    padding: 0px 4px;
    border-bottom-left-radius: 12px;
    overscroll-behavior-y: contain;

    .contact-item {
        cursor: pointer;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        border-radius: 12px;
        padding: 0px 8px;
        height: 56px;

        .chatImgWrapper {
            position: relative;
            margin-right: 8px;
            flex-shrink: 0;
            height: 26px;

            .chatImg {
                width: 26px;
                height: 26px;
                border-radius: 50%;
            }
        }

        .chatContent {
            -webkit-box-flex: 1;
            flex-grow: 1;
            overflow: hidden;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            flex-wrap: wrap;
            padding: 8px 0px;

            .chatName {
                font-size: 12px;
                font-weight: normal;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin: 0px;
                line-height: 22px;
                width: 100%;
                color: var(--NN950, rgba(33, 33, 33, 0.96));
            }

            .text-bold {
                font-weight: bold;
            }
        }
    }
    .contact-item:hover {
        background-color: #eff0f1;
    }
    .selected-chatroom {
        background-color: #bcddff;
    }
    .selected-chatroom:hover {
        background-color: #bcddff;
    }
}

.left-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
}

.topist {
    display: flex;
    -webkit-box-pack: start;
    justify-content: flex-start;
    min-height: 56px;
    z-index: 100;
    -webkit-box-align: center;
    align-items: center;
    height: 56px;
    padding: 10px 8px 10px 16px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 4px 0px;
    justify-content: space-between;

    .close-wrapper {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: end;
        justify-content: flex-end;
        height: 44px;
        padding-right: 8px;
    }
}

.no-active-chat-topist {
    justify-content: flex-end;
}

.empty-chatroom-wrapper {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    padding: 24px;
}

.chat-user-wrapper {
    display: flex;
    .user-avatar {
        flex: 0 0 auto;
        width: 36px;
        height: 36px;
        position: relative;
        cursor: pointer;
        .headerImg {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .user-info {
        -webkit-box-flex: 1;
        flex-grow: 1;
        margin-left: 8px;
        width: calc(100% - 164px);
        cursor: pointer;
        .user-name {
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            p {
                color: var(--NN700, #525867);
                font-weight: bold;
                line-height: 22px;
                margin: 0px 4px 0px 0px;
                font-size: 14px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
        }
        p {
            font-size: 10px;
            color: var(--NN950, rgba(33, 33, 33, 0.68));
            font-weight: 400;
            margin: 0px;
            line-height: 13px;
        }
    }
}

.chatroom-wrapper {
    display: flex;
    flex-direction: column;
    height: calc(100% - 56px);
    position: relative;
}
.chatroom {
    position: relative;
    -webkit-box-flex: 1;
    flex-grow: 1;
    padding: 0px 16px;
    overflow-y: auto;
    overscroll-behavior-y: contain;

    .chatbox {
        margin-bottom: 8px;
    }

    .chat-item-right {
        margin-top: 8px;
        display: flex;
        position: relative;
        -webkit-box-pack: end;
        justify-content: flex-end;
        .chat-bubble {
            display: flex;
            flex-direction: column;
            max-width: 70%;
            position: relative;
            -webkit-box-pack: end;
            justify-content: flex-end;
            .chat-bubble-inner:first-child {
                margin-top: 0px;
            }
            .chat-bubble-inner {
                position: relative;
                color: var(--NN950, rgba(33, 33, 33, 0.96));
                text-align: left;
                display: inline-block;
                padding: 6px 12px;
                max-width: 330px;
                border: none;
                background-color: var(--NN50, #f0f3f7);
                border-radius: 20px 0px 20px 20px;
            }
            .chat-text {
                word-break: break-word;
                font-size: 13px;
                line-height: 20px;
                display: inline;
                white-space: pre-line;
            }
            .chat-time-status {
                float: right;
                margin: 0px 0px 0px 8px;

                .chat-time-status-inner {
                    display: flex;
                    -webkit-box-align: center;
                    align-items: center;
                    -webkit-box-pack: end;
                    justify-content: flex-end;
                    margin-bottom: -2px;
                    .time-text {
                        color: var(--NN950, rgba(33, 33, 33, 0.44));
                        font-size: 11px;
                        margin-left: 0px;
                        line-height: 16px;
                    }
                }
            }
        }
    }

    .chat-item-left {
        margin-top: 8px;
        display: flex;
        position: relative;
        -webkit-box-pack: start;
        justify-content: flex-start;
        .chat-bubble {
            display: flex;
            flex-direction: column;
            max-width: 70%;
            position: relative;
            -webkit-box-pack: start;
            justify-content: flex-start;
            .chat-bubble-inner:first-child {
                margin-top: 0px;
            }
            .chat-bubble-inner {
                position: relative;
                color: var(--NN950, rgba(33, 33, 33, 0.96));
                text-align: left;
                display: inline-block;
                padding: 6px 12px;
                max-width: 330px;
                border: solid 1px var(--NN50, #f0f3f7);
                background-color: var(--NN0, #ffffff);
                border-radius: 0px 20px 20px;
            }
            .chat-text {
                word-break: break-word;
                font-size: 13px;
                line-height: 20px;
                display: inline;
                white-space: pre-line;
            }
            .chat-time-status {
                float: right;
                margin: 4px 0px 0px 8px;
                .chat-time-status-inner {
                    display: flex;
                    -webkit-box-align: center;
                    align-items: center;
                    -webkit-box-pack: end;
                    justify-content: flex-end;
                    margin-bottom: -2px;
                    .time-text {
                        color: var(--NN950, rgba(33, 33, 33, 0.44));
                        font-size: 11px;
                        margin-left: 0px;
                        line-height: 16px;
                    }
                }
            }
        }
    }
}

.center-spin {
    position: absolute;
    right: 50%;
    top: 50%;
}

.chat-image {
    overflow: hidden;
    position: relative;
    border-radius: 0px 20px 20px;
    margin-top: 4px;
    display: inline-block;
    img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }
}

.chat-time-image {
    position: absolute;
    right: 12px;
    bottom: 8px;

    .chat-image-container {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: end;
        justify-content: flex-end;
        margin-bottom: -2px;

        .chat-image-span {
            color: var(--NN0, #ffffff);
            font-size: 11px;
            margin-left: 0px;
            line-height: 16px;
        }
    }
}

.chat-with-context {
    display: flex;
    -webkit-box-pack: end;
    justify-content: flex-end;
    margin: 0 0 4px 0;

    .inner {
        width: 250px;
        height: 100%;
        background-color: var(--NN0, #ffffff);
        border: none;
        box-shadow: rgba(49, 53, 59, 0.12) 0px 1px 6px;
        border-radius: 8px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        -webkit-box-pack: justify;
        justify-content: space-between;
        cursor: pointer;
    }

    .inner .context-content {
        display: flex;
        .context-image-container {
            width: 72px;
            height: 72px;
            flex-shrink: 0;
            position: relative;

            .context-image {
                height: 100%;
                width: 100%;
                border-radius: 8px;
                border-style: none;
            }
        }
        .context-text-container {
            margin-left: 8px;
            text-align: left;

            .title-context {
                position: relative;
                font-weight: 400;
                font-family: 'Open Sauce One', -apple-system, BlinkMacSystemFont,
                    Roboto, sans-serif;
                font-size: 12px;
                line-height: 16px;
                color: var(--color-text-high, rgba(49, 53, 59, 0.96));
                text-decoration: initial;
                margin: 0 0 4px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                overflow-wrap: anywhere;
                word-break: break-word;
                text-transform: capitalize;
            }
            .context-tag-container {
                display: inline-flex;
                .context-tag {
                    display: inline-flex;
                    -webkit-box-align: center;
                    align-items: center;
                    -webkit-box-pack: justify;
                    justify-content: space-between;
                    border-radius: 3px;
                    position: relative;
                    overflow: hidden;
                    padding: 2px 4px;
                    margin-right: 4px;
                    height: 20px;
                    background: var(--NN50, #f0f3f7);
                    color: var(--G500, #03ac0e);
                }
                .context-tag p {
                    display: block;
                    position: relative;
                    font-weight: 800;
                    font-family: 'Open Sauce One', -apple-system,
                        BlinkMacSystemFont, Roboto, sans-serif;
                    font-size: 10px;
                    line-height: 12px;
                    color: var(--color-text-low, rgba(49, 53, 59, 0.68));
                    text-decoration: initial;
                    margin: 0px;
                    text-transform: capitalize;
                }
            }
            .bold-text {
                display: block;
                position: relative;
                font-weight: 800;
                font-family: 'Open Sauce One', -apple-system, BlinkMacSystemFont,
                    Roboto, sans-serif;
                font-size: 14px;
                line-height: 18px;
                color: var(--color-text-high, rgba(49, 53, 59, 0.96));
                text-decoration: initial;
                margin: 4px 0px;

                .rent-duration {
                    font-size: 12px;
                    font-weight: 400;
                }
                .start-from {
                    font-size: 11px;
                    font-weight: 400;
                }
            }
            .regular-text {
                color: var(--NN600, #6d7588);
                font-size: 9px;
            }
        }
    }

    .inner .cta-button {
        display: flex;
        margin-top: 8px;

        .button-container {
            width: 100%;

            button {
                color: var(--NN600, #6d7588);
                cursor: pointer;
                width: 100%;
                height: 32px;
                color: var(--NN600, #6d7588);
                font-size: 12px;
                font-weight: 700;
                line-height: 16px;
                text-overflow: ellipsis;
                white-space: nowrap;
                outline: none;
                border-radius: 8px;
                display: flex;
                -webkit-box-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                align-items: center;
                overflow: hidden;
                position: relative;
                padding: 0px 16px;
                transition: background 300ms ease 0s, border 300ms ease 0s,
                    color 300ms ease 0s;
                background: transparent;
                border: 1px solid var(--NN300, #bfc9d9);
                font-family: inherit;
            }

            button::before {
                content: '.';
                max-width: 0px;
                width: 0px;
                opacity: 0;
                visibility: hidden;
            }

            .button-text-container {
                min-width: 0px;
                display: inline-flex;
                -webkit-box-align: center;
                align-items: center;
                position: relative;
                bottom: 0px;
                opacity: 1;
                transition: opacity 300ms cubic-bezier(0.63, 0.01, 0.29, 1) 0s,
                    bottom 300ms cubic-bezier(0.63, 0.01, 0.29, 1) 0s;
            }
            .button-text-container span {
                overflow: hidden;
                text-overflow: ellipsis;
                flex-shrink: 1;
            }
        }
    }

    .inner .checkmark {
        position: relative;
        font-weight: 400;
        font-family: 'Open Sauce One', -apple-system, BlinkMacSystemFont, Roboto,
            sans-serif;
        font-size: 12px;
        line-height: 16px;
        color: var(--color-text-disabled, rgba(49, 53, 59, 0.32));
        text-decoration: initial;
        display: block;
        text-align: right;
        margin: 2px 0px 0px 8px;

        .checkmark-wrapper {
            text-align: right;
            margin-top: 2px;
            margin-right: 4px;
        }

        .aligner {
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: end;
            justify-content: flex-end;
            margin-bottom: -2px;
        }
        .time-jumble {
            color: var(--NN950, rgba(33, 33, 33, 0.44));
            font-size: 11px;
            margin-left: 0;
            line-height: 16px;
        }
    }
}

.action-container {
    box-shadow: rgba(0, 0, 0, 0.08) 0px -1px 2px 0px;
    padding: 10px 16px;

    .btn-send-message {
        height: 42px;
        width: 42px;
        border: none;
        padding: 0px;
        margin-left: 8px;
        border-radius: 50%;
        background-color: var(--GN500, #00aa5b);
        cursor: pointer;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        flex-shrink: 0;
        -webkit-box-pack: center;
        justify-content: center;
    }
    .action-wrapper {
        display: flex;
        align-items: flex-end;
    }
    .input-container {
        position: relative;
        -webkit-box-flex: 1;
        flex-grow: 1;
        width: calc(100% - 42px);
        display: flex;
        align-items: flex-end;
    }
    .textarea-container {
        position: relative;
        -webkit-box-flex: 1;
        flex-grow: 1;
        display: flex;
        .chatbox-input {
            position: relative;
            display: grid;
            background-color: var(--NN50, #f0f3f7);
            border: none;
            border-radius: 20px;
            height: auto;
            width: 100%;
            .chat-textbox {
                resize: none;
                background-color: var(--NN0, #ffffff);
                width: 100%;
                margin-bottom: 0px;
                line-height: 20px;
                color: var(--NN800, #40444e);
                overflow-x: hidden;
                border: 1px solid var(--NN50, #f0f3f7) !important;
                border-radius: 20px !important;
                padding: 10px 34px 10px 40px !important;
                font-size: 13px !important;
            }
            .image-uploader {
                position: absolute;
                bottom: 9px;
                left: 9px;
            }
        }
    }
}

.day-break {
    text-align: center;
    margin: 12px 0 8px;

    span {
        color: rgba(0, 0, 0, 0.38);
        font-size: 12px;
    }
}

// Mobile View
@media only screen and (min-device-width: 0px) and (max-device-width: 699px) {
    #floating-chatroom {
        width: 94%;
        right: 3%;
    }
}
</style>
